<template>
<div>
  <rapor title="E Fatura" v-on:kayitgetir="kayitgetir" v-on:edititem="edititem" v-on:beforeedititem="beforeedititem" :tableheaders="headers" :tableitems="items" :item="item" :status="status" :insert="true" dialogmaxwidth="1200px">
    <template slot-scope="props">
      <!--
      <td>{{ props.item["GuId"]}}</td>
      <td>{{ props.item["HesapKodu"]}}</td>
      <td>{{ props.item["OFatura"].seriYilNo}}</td>
      <td>{{ props.item["SendFatura"].seriYilNo}}</td>

      <td>{{ props.item["OnayFaturaNo"]}}</td>
      <td>{{ props.item["faturaProgrami"]}}</td>
      <td>{{ props.item["Fatura"].tarih}}</td>
      -->
    </template>

    <template slot="dialogmain" slot-scope="prop">
      <v-text-field hide-details label="Ref" v-model="prop.item.Ref"></v-text-field>

      <span id="demo"></span>
    </template>

    <template slot="dialogbutton">
      <v-btn color="primary" flat onclick="printJS('demo','html')">Yazdır</v-btn>
      <v-btn color="primary" flat @click.native="ReportBroYazdir()">Report Bro Yazdır</v-btn>
    </template>

    <template slot="toolbarbottom">
      <v-layout row wrap>
        <div class="flex sm5">
          <v-radio-group v-model="radioGroup" row>
            <v-radio label="E Fatura" :value="0"></v-radio>
            <v-radio label="E Arşiv" :value="1"></v-radio>
          </v-radio-group>
        </div>
        
      </v-layout>
      <reportbrosablon menudisable ref="reportbrosablon" v-model="dizayn" dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
      <reportbrosablon  ref="reportbrosablon" v-model="dizayn" dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
      
      <v-text-field hide-details label="Dizayn Id" v-model="dizayn"></v-text-field>
        {{dizayn}}

    </template>
  </rapor>
</div>
</template>

<script>
import rapor from "@/components/app/coper/comp/rapor.vue";
import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
import auth from "../../../api/auth";

import tool from "../coper/tools";
import print from "print-js";
//import rez from "../../rezervasyon";

export default {
  components: {
    rapor,
    reportbrosablon
  },
  data() {
    return {
      status: tool.NewSatatus(),
      radioGroup: 0,
      dizayn: 26,
      dizayn2: null,
      dizaynid:0,
      
      headers: [{
          text: "GuId",
          value: "GuId"
        },
        {
          text: "HesapKodu",
          value: "HesapKodu"
        },
        {
          text: "Proforma",
          value: "OFatura",
          value2: "seriYilNo"
        },
        {
          text: "Send Fatura No",
          value: "SendFatura",
          value2: "seriYilNo"
        },
        {
          text: "OnayFatura",
          value: "OnayFaturaNo"
        },
        {
          text: "Program",
          value: "faturaProgrami"
        },
        {
          text: "Fatura",
          value: "Fatura",
          value2: "tarih"
        },
        {
          text: "İşlem",
          value: "islemsutunu",
          sortable: false
        }
      ],

      items: [],
      item: {
        Ref: "",
        GuId: ""
      }
    };
  },
  methods: {
    kayitgetir: kayitgetir,
    edititem: edititem,
    beforeedititem: beforeedititem,
    ReportBroYazdir: ReportBroYazdir
  },
  beforeMount: beforeMount
};

function ReportBroYazdir() {
  var prm = {
    id: this.item.Ref,
    guid: this.item.GuId
  };
  this.status.loading = true;
  this.$refs.reportbrosablon.Print(prm).then(
    confirm => {
      this.status.loading = false;
    },
    confirm => {
      this.status.loading = false;
    }
  );
}

function beforeMount() {}

function beforeedititem(val) {
  var prm = {
    id: val.Ref,
    guid: val.GuId
  };
  this.item = val;

  
    this.status.loading = true;
    //tool.api_post(this, "EFatura/FaturaShow", prm).then(
    tool.api_post(this, "EFatura/FaturaPDF", prm).then(

      response => {
        //this.items = response.body;
        //console.log(response.body);
        document.getElementById("demo").innerHTML = response.body;

        this.status.loading = false;
      },
      response => {
        this.status = tool.responseToStatus(response);
      }
    );
  
}

function edititem(val) {
  //var i = this.items.findIndex(k => k.Ref == val.Ref);
  //Object.assign(this.items[i], val);
  //this.kayitupdate(val);
}

function kayitgetir(val) {
  var prm = {
    eArsiv: this.radioGroup
  };

  this.status.loading = true;
  tool.api_post(this, "EFatura/GonderilecekFaturaListesiGetir", prm).then(
    response => {
      this.items = response.body;

      this.status.loading = false;
      //console.log(response.body);
      //this.status.show = true;
      //this.status.text = "Kayıt getirildi";
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}
</script>
